var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar p-5 w-100 d-flex justify-content-between align-items-center"},[_c('a',{staticClass:"logo",attrs:{"href":"/"}},[_vm._v("stay")]),_vm._v(" "),_c('a',{attrs:{"href":"/user/login","id":"login_button"}},[_vm._v("login")])])
}]

export { render, staticRenderFns }